import { UseFormReturn } from "react-hook-form";
import NumberEditor from "../Global/Editors/NumberEditor";
import { DTOModule } from "../../types/building";
import { IModuleVattenburetSekundärsystemConfig } from "../../types/ModuleDatas";
import StaticBox from "../Global/StaticBox";
import { useGlobalData } from "../GlobalDataProvider";
import { nameof } from "../Global/Utils";
import { MapTooltip } from "../../types/globalData";

interface IProps {
  module: DTOModule;
  data: any;
  formHook: UseFormReturn;
}

const ConfigVarmeSekundarVatten = ({ module, data, formHook }: IProps) => {
  const globalData = useGlobalData();
  const mt = globalData.moduleTypes.find((mt) => mt.id === module.moduleTypeId);
  const mtDisplayName = mt ? mt.displayName : "";

  return (
    <>
      <div className="row ml-0">
        <div className="col-lg-12">
          <StaticBox label="Benämning på system" text={module.name}></StaticBox>
        </div>
        <div className="col-lg-12">
          <StaticBox label="Värmeavgivare" text={mtDisplayName}></StaticBox>
        </div>
        <div className="col-lg-12">
          <StaticBox
            label="Systemandel (%)"
            text={data[nameof<IModuleVattenburetSekundärsystemConfig>("värmeSystemandel")]}
            tooltipId={nameof<MapTooltip>("VärmeSekundär_värmeSystemandel")}
          ></StaticBox>
        </div>
        <div className="col-lg-12">
          <StaticBox
            label="Betjäningsområde"
            text={data[nameof<IModuleVattenburetSekundärsystemConfig>("betjäningsområde")]}
            tooltipId={nameof<MapTooltip>("VärmeSekundär_betjäningsområde")}
          ></StaticBox>
        </div>
        <div className="col-lg-12">
          <NumberEditor
            label="Cirkulationspumpens EL effekt (W)"
            fieldName={nameof<IModuleVattenburetSekundärsystemConfig>("elEffekt")}
            tooltipId={nameof<MapTooltip>("VärmeSekundär_elEffekt")}
            formHook={formHook}
            options={{
              validate: {
                negativeNumber: (value: any) => (parseFloat(value) <= 0 ? "Måste vara positivt värde" : undefined),
                required: (value: any) => (value ? undefined : "Måste fyllas i"),
              },
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ConfigVarmeSekundarVatten;
